import { RecommendationsTab } from './RecommendationsTab'

/**
 * Visão filtrada da tabela unificada: otimização de compute EC2 — rightsizing
 * (downsize por baixo uso) + graviton_migration (migração x86→ARM/Graviton).
 */
export function RightsizingTab() {
  return <RecommendationsTab recTypes={['rightsizing', 'graviton_migration']} />
}